import { render, staticRenderFns } from "./MarketChangeGraph.vue?vue&type=template&id=708810ec&scoped=true"
import script from "./MarketChangeGraph.vue?vue&type=script&lang=js"
export * from "./MarketChangeGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708810ec",
  null
  
)

export default component.exports